<template>
    <!-- 告警记录 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'recordSmartWrist')">
            <div slot="header">
                <a-form :form="form" layout="inline">
                    <a-form-item label="告警日期">
                        <a-range-picker style="width:282px" format="YYYY/MM/DD" v-decorator="['warnDay',{initialValue: [$moment().subtract(6,'days'),$moment()]}]" />
                    </a-form-item>
                    <!-- <a-form-item label="告警门店">
                        <a-select allowClear placeholder="请选择" v-decorator="['shopId']">
                            <a-select-option v-for="item in shopList" :value="item.id" :key="item.id">{{item.name}}</a-select-option>
                        </a-select>
                    </a-form-item> -->
                    <a-form-item label="告警类型">
                        <a-select allowClear placeholder="请选择" v-decorator="['warnType']" >
                            <a-select-option value="0">儿童告警</a-select-option>
                            <a-select-option value="1">进出场告警</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="告警状态">
                        <a-select allowClear placeholder="请选择" v-decorator="['status']" >
                            <a-select-option value="0">未处理</a-select-option>
                            <a-select-option value="1">已处理</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="告警项">
                        <a-select allowClear placeholder="请选择" v-decorator="['warnOption']" >
                            <a-select-option value="0">儿童出场告警</a-select-option>
                            <a-select-option value="2">非法设备进场告警</a-select-option>
                            <a-select-option value="1">非法设备出场告警</a-select-option>
                            <a-select-option value="3">超时未入场告警</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button @click="search" class="mr8" type="primary">搜索</a-button>
                        <a-button @click="handleReset">重置</a-button>
                    </a-form-item>
                </a-form>
            </div>
            <div class="wrap-container-in">
                <div class="mb16">
                    <a-button class="text-right" @click="exportExcel" v-if="getBtnByAuth('recordSmartWristExport')" >导出</a-button>
                </div>
                <a-table :scroll="{x:800}" bordered :dataSource="dataSource" :columns="columns" :pagination="pagination" @change="changePage" :rowKey="record => record.id">
                    <span slot="shopName" slot-scope="shopName">{{shopName || "-"}}</span>
                    <span slot="deviceId" slot-scope="deviceId">{{deviceId || "-"}}</span>
                    <span slot="warnType" slot-scope="warnType">{{['儿童告警','进出场告警'][warnType]}}</span>
                    <span slot="warnOption" slot-scope="warnOption">{{['儿童出场告警','设备非法出场告警','非法设备进场告警','超时未入场告警'][warnOption]}}</span>
                    <span slot="status" slot-scope="status"><a-badge :status="status==1?'success':'error'" />{{['未处理','已处理'][status]}}</span>
                    <span slot="mobile" slot-scope="mobile">{{mobile || "-"}}</span>
                    <span slot="sendSmsTime" slot-scope="sendSmsTime">{{sendSmsTime ? '' : "-"}} <a-icon v-if="sendSmsTime" type="message" /></span>
                    <span slot="operator" slot-scope="operator">{{operator || "-"}}</span>
                    
                    <span slot="action" slot-scope="a, row">
                        <span v-if="getBtnByAuth('recordSmartWristDetail')">
                            <a class="text-primary" @click="openDialog(row.id)">查看</a>
                        </span>
                    </span>
                </a-table>
            </div>
            <alarm-dialog :visible="visible" @changeVisible="changeVisible" :id="id"></alarm-dialog>
        </content-view>
        <router-view></router-view>
    </div>
</template>
<script type="text/javascript">
    import { mapGetters } from "vuex";
    import alarmDialog from '@/components/modules/wrist/alarm.component'
    const columns = [
    {
        title: "告警时间",
        dataIndex: "warnTime"
    },
    {
        title: "告警门店",
        dataIndex: "shopName",
        scopedSlots: {customRender: 'shopName'}
    },
    {
        title: "告警类型",
        dataIndex: "warnType",
        scopedSlots: {customRender: 'warnType'}
    },
    {
        title: "告警项",
        dataIndex: "warnOption",
        scopedSlots: {customRender: 'warnOption'}
    },
    {
        title: "设备ID",
        dataIndex: "deviceId",
        scopedSlots: { customRender: "deviceId" }
    },
    {
        title: "手机号",
        dataIndex: "mobile",
        scopedSlots: { customRender: "mobile" }
    },
    {
        title: "通知用户",
        dataIndex: "sendSmsTime",
        scopedSlots: { customRender: "sendSmsTime" }
    },
    {
        title: "告警状态",
        dataIndex: "status",
        scopedSlots: { customRender: "status" }
    },
    {
        title: "操作人",
        dataIndex: "operator",
        scopedSlots: { customRender: "operator" }
    },
    {
        title: "操作",
        key: "action",
        scopedSlots: { customRender: "action" }
    }]
    export default {
        name: "recordSmartWrist",
        data() {
            return {
                columns,
                dataSource: [],
                shopList: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                loading: false,
                visible: false,
                id: undefined,
            };
        },
        components: {
            alarmDialog
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        methods: {
            changePage(page) {
                this.pagination.pageSize = page.pageSize;
                this.pagination.current = page.current;
                this.getList()
            },
            handleReset() {
                this.form.resetFields();
                this.getList()
            },
            search() {
                this.pagination.current = 1;
                this.getList();
            },
            getShopList() {
                this.$api.totalPlatform.selectList().then(res => {
                    this.shopList = res;
                });
            },

            // 获取购票订单列表
            getList() {
                this.form.validateFields((err, values) => {
                    if (err) return;
                    const warnDay = values['warnDay'] ? values['warnDay'] : []
                    values.warnBeginDay = warnDay.length > 0 ? warnDay[0].format('YYYY-MM-DD') : ''
                    values.warnEndDay = warnDay.length > 0 ? warnDay[1].format('YYYY-MM-DD') : ''

                    this.$api.wrist
                    .warnList({
                        body: Object.assign(values, 
                        {   
                            shopId: this.shopId,
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize
                        })
                    })
                    .then(res => {
                        this.pagination.total = res.total;
                        this.dataSource = res.data;
                    });
                });
            },
            exportExcel() {
                this.form.validateFields((err, values) => {
                    if (err) return;
                    this.loading = true;
                    const warnDay = values['warnDay'] ? values['warnDay'] : []
                    values.warnBeginDay = warnDay.length > 0 ? warnDay[0].format('YYYY-MM-DD') : ''
                    values.warnEndDay = warnDay.length > 0 ? warnDay[1].format('YYYY-MM-DD') : ''
                    this.$api.wrist.warnExport({
                            body: Object.assign(values, {
                                shopId: this.shopId,
                                pageNum: 1,
                                pageSize: 99999999
                            })
                        },
                        {
                            responseType: "blob"
                        })
                        .then(res => {
                            let a = document.createElement("a");
                            let blob = new Blob([res.data], {
                                type: "application/vnd.ms-excel"
                            });

                            this.downloadUrl = window.URL.createObjectURL(blob);

                            let name = '告警记录-' + this.$moment().format('YYYY/MM/DD') + '.xls'

                            a.setAttribute("href", this.downloadUrl);

                            var reportName = decodeURI(name);

                            a.setAttribute("download", reportName);
                            a.click();
                            this.loading = false
                        });
                });
            },
            openDialog(id) {
                this.visible = true;
                this.id = id;
            },
            changeVisible() {
                this.visible = false
                this.getList()
            }

        },
        created() {},
        mounted() {
            this.getShopList()
            this.getList()
        },
        watch: {
            '$route'(val) {
                val.name == 'recordSmartWrist' && this.getList();
            },
            'shopId'(val) {
                this.getList();
            }
        }
    };
</script>
<style lang="scss">
</style>